<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="employeeFaceFormAdd"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleClickBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>
              {{ employee.firstname_th }} {{ employee.lastname_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ employee.employee_code }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <div>
          <label class="body-2">
            รูปภาพ
            <span class="red--text"><strong>*</strong></span>
          </label>
          <div style="position: relative">
            <v-file-input
              class="fix-google-chrome mt-1"
              v-model="file"
              :rules="rules"
              ref="imgFileInput"
              accept="image/jpeg"
              show-size
              @change="onFileChange"
              @click:clear="onFileClear"
              outlined
              dense
              :disabled="
                uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
              "
            >
            </v-file-input>
            <span
              style="
                font-size: 13px;
                color: #555;
                position: absolute;
                top: 45px;
                right: 5px;
              "
            >
              jpeg เท่านั้น / ขนาดไฟล์ไม่เกิน 512kB
            </span>
          </div>
          <v-img
            v-if="filePreview"
            :src="'data:image/jpeg;base64,' + filePreview"
            width="100%"
          ></v-img>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn
            class="primary mr-3"
            depressed
            @click="handleEmployeeFaceFormAdd"
            >ตกลง</v-btn
          >
          <v-btn depressed @click="handleCancel">ยกเลิก</v-btn>
          <div class="d-sr-only">{{ isDataChange }}</div>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      required: true,
    },
    employee: {
      type: Object,
      required: true,
    },
    biometric: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      rules: [
        (v) => !!v || 'จำเป็นต้อง upload รูปภาพ',
        (v) => !v || v.type === 'image/jpeg' || 'รูปภาพต้อง jpeg เท่านั้น',
        (v) => !v || v.size < 500000 || 'รูปภาพต้องมีขนาดไม่เกิน 512 KB',
      ],
      file: null,
      filePreview: null,
    }
  },

  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isDataChange() {
      if (this.file) {
        this.$emit('isEmployeeFaceFormDataChange', true)
        return true
      } else {
        this.$emit('isEmployeeFaceFormDataChange', false)
        return false
      }
    },
    employeeBiometric() {
      return this.$store.state.employee.employeeBiometric
    },
  },

  methods: {
    handleClickBack() {
      if (this.isDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.imgFileInput.reset()
        this.$refs.employeeFaceFormAdd.reset()
        this.file = null
        this.filePreview = null
        this.$emit('onClickBack')
      }
    },

    async onFileChange(file) {
      if (file && this.$refs.imgFileInput.validate()) {
        this.file = file
        const result = await this.getBase64(file)
        this.filePreview = result.split(',').pop()
        // this.filePreview = URL.createObjectURL(file)
      }
    },

    onFileClear() {
      this.file = null
      this.filePreview = null
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },

    handleCancel() {
      this.$refs.imgFileInput.reset()
      this.$refs.employeeFaceFormAdd.reset()
      this.file = null
      this.filePreview = null
      this.$emit('onClickBack')
    },

    async handleEmployeeFaceFormAdd() {
      if (
        this.$refs.employeeFaceFormAdd.validate() &&
        this.$refs.imgFileInput.validate()
      ) {
        try {
          let file_base64 = null
          let file_ext = null
          let file_size_byte = null
          if (this.file) {
            file_base64 = await this.getBase64(this.file)
            file_base64 = file_base64.split(',').pop()
            file_ext = this.file.type.split('/').pop()
            file_size_byte = this.file.size
          }

          let biometricProperty = []

          biometricProperty = this.biometric.biometric_property
            .filter((item) => item.biometric_property_code === 'face')
            .map((item) => ({
              ...item,
              employee_biometric: {
                biometric_property_code: item.biometric_property_code,
                file_base64,
                file_ext: `.${file_ext}`,
                file_size_byte,
              },
            }))

          const employeeBio = this.employeeBiometric.find(
            (e) => e.biometric_code === this.biometric.biometric_code
          )

          const faceData = {
            biometric_code: this.biometric.biometric_code,
            biometric_property: employeeBio
              ? [...employeeBio.biometric_property, ...biometricProperty]
              : [...biometricProperty],
            title_th: this.biometric.title_th,
            title_en: this.biometric.title_en,
          }

          this.$refs.imgFileInput.reset()
          this.$refs.employeeFaceFormAdd.reset()
          this.file = null
          this.filePreview = null
          this.$emit('submitEmployeeFaceFormAdd', faceData)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$refs.imgFileInput.reset()
      this.$refs.employeeFaceFormAdd.reset()
      this.file = null
      this.filePreview = null
      this.$emit('onClickBack')
    },
  },
}
</script>
